export const FONT_FACE = {
  BASE: 'Nobel',
  BOLD: 'Nobel Bold',
  LIGHT: 'Nobel Light',
  BOOK: 'Nobel Book',
};

export const THEME = {
  FONT: {
    face: {
      base: `${FONT_FACE.BASE}, Helvetica ,Arial ,Roboto ,sans-serif`,
      bold: `${FONT_FACE.BOLD}, Helvetica ,Arial ,Roboto ,sans-serif`,
      light: `${FONT_FACE.LIGHT}, Helvetica ,Arial ,Roboto ,sans-serif`,
      book: `${FONT_FACE.BOOK}, Helvetica ,Arial ,Roboto ,sans-serif`,
    },
  },
  COLORS: {
    PRIMARY: {
      black: '#101010',
      midnight: '#1a1a1f',
      white: '#fff',
    },
    SECONDARY: {
      red: '#b12a31',
      green: '#4caf50',
      electrifiedBlue: '#0072f0',
      skyBlue: '#005fb6',
      azureHover: '#4d5e7d',
      azure: '#20365c',
      cloud: '#eeedec',
    },
    GREY: {
      mist: '#f4f6fb',
      silver: '#e2e8ef',
      platinumLight: '#c7cfd7',
      platinumMedium: '#b0b8c0',
      titanium: '#969ca3',
      brushedSteel: '#6c6f76',
      platinumDark: '#52565e',
      steel: '#363840',
    },
  },
};

export const COLORS = {
  BLACK: THEME.COLORS.PRIMARY.black,
  WHITE: THEME.COLORS.PRIMARY.white,
  GREY: THEME.COLORS.GREY.platinumLight,
  GREY_LIGHT: THEME.COLORS.GREY.silver,
  GREY_DARK: THEME.COLORS.GREY.platinumDark,
  RED: THEME.COLORS.SECONDARY.red,
  BLUE: THEME.COLORS.SECONDARY.electrifiedBlue,
  ERROR: THEME.COLORS.SECONDARY.red,
};
